import { createFbEventId, fbqTrack } from '@/utils/fbqTrack'

const DEDUP_STORAGE_KEY = 'fb_initiate_checkout_dedup'
const DEDUP_WINDOW_MS = 5 * 60 * 1000

function readDedupMap(): Record<string, number> {
  try {
    const raw = sessionStorage.getItem(DEDUP_STORAGE_KEY)
    if (!raw)
      return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  }
  catch {
    return {}
  }
}

function writeDedupMap(map: Record<string, number>) {
  try {
    sessionStorage.setItem(DEDUP_STORAGE_KEY, JSON.stringify(map))
  }
  catch {}
}

export function useFbqInitiateCheckout() {
  /**
   * 创建订单时上报 InitiateCheckout，生成并返回 eventId 供透传后端 + 带入 /paying 复用
   * @returns eventId（命中去重或 fbq 不可用时返回 undefined）
   */
  function reportInitiateCheckout(params: {
    value: number
    currency: string
    contentIds: string[]
    /** 商品名称，取商品 name 字段（例如 "web-stripe-19.9"、"4.99-paypal-web"） */
    contentName: string
    /** 支付类型：充值 product / 订阅 subscription */
    contentCategory: 'product' | 'subscription'
    /** 是否启用 5 分钟同单去重（订阅需要，充值不需要） */
    dedup?: boolean
  }): string | undefined {
    if (params.dedup) {
      const key = [...params.contentIds].sort().join('|')
      const now = Date.now()
      const map = readDedupMap()
      const last = map[key]
      if (last && now - last < DEDUP_WINDOW_MS)
        return undefined

      for (const k of Object.keys(map)) {
        if (now - map[k] >= DEDUP_WINDOW_MS)
          delete map[k]
      }
      map[key] = now
      writeDedupMap(map)
    }

    const eventId = createFbEventId('InitiateCheckout')
    fbqTrack('InitiateCheckout', {
      value: params.value,
      currency: params.currency,
      content_ids: params.contentIds,
      content_name: params.contentName,
      content_category: params.contentCategory,
    }, eventId)
    return eventId
  }

  return { reportInitiateCheckout }
}
